import { Sort } from '../../../utils/api';
import { CLOVER_DEV_ID } from '../../../utils/constants';

const BASE_DROPDOWN_KEY = 'drop_down';

export interface FilterRecord {
  label: string;
  value: Filters;
  sort?: Sort;
  filters?: string[];
}

export enum Filters {
  MostRelevant = '1',
  TopRated = '2',
  Newest = '3',
  MostPopular = '4',
  MostInstalled = '5',
  CloverApps = '6',
  NonCloverApps = '7'
}

export const FiltersMap: Record<Filters, FilterRecord> = {
  [Filters.MostRelevant]: {
    label: `${BASE_DROPDOWN_KEY}.most_relevant`,
    value: Filters.MostRelevant,
  },
  [Filters.TopRated]: {
    sort: {
      name: 'weighted_rating',
      direction: 'DESC',
    },
    label: `${BASE_DROPDOWN_KEY}.top_rated`,
    value: Filters.TopRated,
  },
  [Filters.Newest]: {
    sort: {
      name: 'first_published_time',
      direction: 'DESC',
    },
    label: `${BASE_DROPDOWN_KEY}.newest`,
    value: Filters.Newest,
  },
  [Filters.MostPopular]: {
    sort: {
      name: 'popularity',
      direction: 'DESC',
    },
    label: `${BASE_DROPDOWN_KEY}.most_popular`,
    value: Filters.MostPopular,
  },
  [Filters.MostInstalled]: {
    label: `${BASE_DROPDOWN_KEY}.most_installed`,
    value: Filters.MostInstalled,
  },
  [Filters.CloverApps]: {
    label: `${BASE_DROPDOWN_KEY}.clover_apps`,
    value: Filters.CloverApps,
    filters: [`developer.id=${CLOVER_DEV_ID}`, 'installed=true'],
    sort: {
      name: 'name',
      direction: 'ASC'
    }
  },
  [Filters.NonCloverApps]: {
    label: `${BASE_DROPDOWN_KEY}.non_clover_apps`,
    value: Filters.NonCloverApps,
    filters: [`developer.id!=${CLOVER_DEV_ID}`, 'installed=true'],
    sort: {
      name: 'name',
      direction: 'ASC'
    }
  },
};

export const getFilterSortInfoFromFilterKey = (filterKey: Filters): Maybe<Sort> => FiltersMap[filterKey]?.sort;
